module.exports = "- Announce the content of each search result.\n"